import { render } from "./PriceAlert.vue?vue&type=template&id=78d94232&scoped=true"
import script from "./PriceAlert.vue?vue&type=script&lang=js"
export * from "./PriceAlert.vue?vue&type=script&lang=js"

import "./PriceAlert.vue?vue&type=style&index=0&id=78d94232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d94232"]])

export default __exports__